import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Workflow_Step_Definition.css';

const Workflow_Step_Definition = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"WORKFLOW_STEP_DEFINITION",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	WORKFLOW_STEP_DEFINITION:-1
  });


  const [WORKFLOW_STEP_DEFINITION, setWORKFLOW_STEP_DEFINITION] = React.useState(null);
  const [WORKFLOW_STEP_DEFINITION_D, setWORKFLOW_STEP_DEFINITION_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Workflow Step Definition');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewWORKFLOW_STEP_DEFINITION(clientInfo,"OpenNew");

		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutWORKFLOW_STEP_DEFINITION(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostWORKFLOW_STEP_DEFINITION(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewWORKFLOW_STEP_DEFINITION(clientInfo,"OpenNew");
		}
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
		if(Temp_Data2.status!="New"){
			handleDeleteWORKFLOW_STEP_DEFINITION(Temp_Data2);
			navigate('/Workflow_Step_Definition#New',{replace:true});
		} 
		else 
			navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Workflow_Step_Definition',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!WORKFLOW_STEP_DEFINITION) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [WORKFLOW_STEP_DEFINITION]) ;


  
  
  var Ids = [];
  for(var Ele in WORKFLOW_STEP_DEFINITION){
	  for(var Sec in WORKFLOW_STEP_DEFINITION[Ele]){
		if(Sec == "id")
			Ids.push(WORKFLOW_STEP_DEFINITION[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(WORKFLOW_STEP_DEFINITION[Ele]["status"]);
		else if(Array.isArray(WORKFLOW_STEP_DEFINITION[Ele][Sec]))
			  for(var Row in WORKFLOW_STEP_DEFINITION[Ele][Sec])  // Convert to WORKFLOW_STEP_DEFINITION[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in WORKFLOW_STEP_DEFINITION[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["WORKFLOW_STEP_DEFINITION"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewWORKFLOW_STEP_DEFINITION(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION`).then((response1) => {
		if(!WORKFLOW_STEP_DEFINITION) 
			setWORKFLOW_STEP_DEFINITION(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION_D`).then((response2) => {
			setWORKFLOW_STEP_DEFINITION_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddWORKFLOW_STEP_DEFINITION_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewWORKFLOW_STEP_DEFINITION = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setWORKFLOW_STEP_DEFINITION(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataWORKFLOW_STEP_DEFINITION = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutWORKFLOW_STEP_DEFINITION = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostWORKFLOW_STEP_DEFINITION = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteWORKFLOW_STEP_DEFINITION = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/WORKFLOW_STEP_DEFINITION', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["4"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"]=value;
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4",value,Temp_Data);
 	//handleLastDataWORKFLOW_STEP_DEFINITION(Temp_Data);
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));  
  Temp_Data['2'][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"] = value;
  setWORKFLOW_STEP_DEFINITION(Temp_Data);
};


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));  
  Temp_Data['2'][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"] = value;
  setWORKFLOW_STEP_DEFINITION(Temp_Data);
};


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));  
  Temp_Data['2'][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"] = value;
  setWORKFLOW_STEP_DEFINITION(Temp_Data);
};


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["2"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3"]=value;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["2"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4"]=value;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));  
  Temp_Data['3'][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"] = value;
  setWORKFLOW_STEP_DEFINITION(Temp_Data);
};


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["3"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1"]=value;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 
  
  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["3"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"]=value ? true : false;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 

  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["3"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"]=value ? true : false;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 

  


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
	Temp_Data["3"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"]=value ? true : false;
    setWORKFLOW_STEP_DEFINITION(Temp_Data);
	//handleAddWORKFLOW_STEP_DEFINITION(Temp_Data,App_Data['WORKFLOW_STEP_DEFINITION']);
  }; 




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!WORKFLOW_STEP_DEFINITION) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4']='';
	    break;
	  case('3'):
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4']='';
	    break;

  }


  const updatedWORKFLOW_STEP_DEFINITION =JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
  updatedWORKFLOW_STEP_DEFINITION[Sec] = [...updatedWORKFLOW_STEP_DEFINITION[Sec], newRow];
  setWORKFLOW_STEP_DEFINITION(updatedWORKFLOW_STEP_DEFINITION);
};

const handleDeleteRow = (sec,index) => {
  const updatedWORKFLOW_STEP_DEFINITION = JSON.parse(JSON.stringify(WORKFLOW_STEP_DEFINITION));
  updatedWORKFLOW_STEP_DEFINITION[sec].splice(index, 1);
  setWORKFLOW_STEP_DEFINITION(updatedWORKFLOW_STEP_DEFINITION);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Workflow Step Definition`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Workflow Step ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow Step ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0" type="text" className="form-control" placeholder="Workflow Step ID" value={WORKFLOW_STEP_DEFINITION["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow Step ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Workflow ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1" type="text" className="form-control" placeholder="Workflow ID" value={WORKFLOW_STEP_DEFINITION["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Workflow ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step Number`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2" type="text" className="form-control" placeholder="Step Number" value={WORKFLOW_STEP_DEFINITION["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Step Number`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3" type="text" className="form-control" placeholder="Step Name" value={WORKFLOW_STEP_DEFINITION["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Step Name`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_HEADER">{t(`Step I/O Mapping Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Step IO Mapping Type`)}</th>
                        <th>{t(`Responsible Stakeholder Type`)}</th>
                        <th>{t(`Responsible Role`)}</th>
                        <th>{t(`Input Form Table`)}</th>
                        <th>{t(`Output Form Table`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {WORKFLOW_STEP_DEFINITION['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0"  onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_0`]} name="Step IO Mapping Type">
						  <option value="Input Form">Input Form</option>
						  <option value="Output Form">Output Form</option>
						  <option value="Responsible Role">Responsible Role</option>
						  <option value="Notification Target">Notification Target</option>
						  <option value="Escalation Target">Escalation Target</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1"  onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_1`]} name="Responsible Stakeholder Type">
						  <option value="Platform Admin">Platform Admin</option>
						  <option value="Project Owner">Project Owner</option>
						  <option value="Developer">Developer</option>
						  <option value="Property Manager">Property Manager</option>
						  <option value="Inspector">Inspector</option>
						  <option value="Appraiser">Appraiser</option>
						  <option value="Title Company">Title Company</option>
						  <option value="Escrow Agent">Escrow Agent</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Broker-Dealer">Broker-Dealer</option>
						  <option value="Transfer Agent">Transfer Agent</option>
						  <option value="Investor">Investor</option>
						  <option value="Auditor">Auditor</option>
						  <option value="Contractor">Contractor</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2"  onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_2`]} name="Responsible Role">
						  <option value="Submitter">Submitter</option>
						  <option value="Reviewer">Reviewer</option>
						  <option value="Approver">Approver</option>
						  <option value="Verifier">Verifier</option>
						  <option value="Signer">Signer</option>
						  <option value="Observer">Observer</option>
						  <option value="Escalation Owner">Escalation Owner</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_3`]} placeholder="Input Form Table"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_2_4`]} placeholder="Output Form Table"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_HEADER">{t(`Approval Rule Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Approval Rule Type`)}</th>
                        <th>{t(`Approval Form Table`)}</th>
                        <th>{t(`Can Reject`)}</th>
                        <th>{t(`Can Request Revision`)}</th>
                        <th>{t(`Blocks Next Step`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {WORKFLOW_STEP_DEFINITION['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0"  onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_0`]} name="Approval Rule Type">
						  <option value="Standard Approval">Standard Approval</option>
						  <option value="Dual Approval">Dual Approval</option>
						  <option value="Compliance Approval">Compliance Approval</option>
						  <option value="Legal Approval">Legal Approval</option>
						  <option value="Escalation Rule">Escalation Rule</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_1`]} placeholder="Approval Form Table"/>
							  </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2`]  === true? e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3`]  === true? e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_3`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4`]  === true? e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_3_4`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Step SLA Days`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Step SLA Days`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0" type="text" className="form-control" placeholder="Step SLA Days" value={WORKFLOW_STEP_DEFINITION["4"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Step SLA Days`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Escalation Role`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1"  value={WORKFLOW_STEP_DEFINITION["4"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1`]} onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_4_1_Change} className="form-control" name="Escalation Role"  >
						  <option value="Operations Manager">Operations Manager</option>
						  <option value="Compliance Officer">Compliance Officer</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Chief Risk Officer">Chief Risk Officer</option>
						  <option value="Platform Administrator">Platform Administrator</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Escalation Role
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0"  value={WORKFLOW_STEP_DEFINITION["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0`]} onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1" type="text" className="form-control" placeholder="Created By" value={WORKFLOW_STEP_DEFINITION["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2" type="text" className="form-control" placeholder="Created At" value={WORKFLOW_STEP_DEFINITION["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3" type="text" className="form-control" placeholder="Updated By" value={WORKFLOW_STEP_DEFINITION["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4" type="text" className="form-control" placeholder="Updated At" value={WORKFLOW_STEP_DEFINITION["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_WORKFLOW_STEP_DEFINITION_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Workflow_Step_Definition;  